/** @format */

import React, { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { Card, Table, TableBody, TableFooter, TableHead, TableRow } from '@material-ui/core';
import Storage from '@material-ui/icons/Storage';
import CardBody from '../../components/Card/CardBody';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import TableCell from '@material-ui/core/TableCell';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { PliCbd2CollectionInterface } from '../../interfaces/collections/PliCbd2CollectionInterface';
import Pager from '../../components/Adescom/PagerRange';
import PliCbd2Interface from '../../interfaces/platform/PliCbd2Interface';
import { PliCbd2PortInRow } from './lib/PliCbd2PortInRow';
import I18n from '../../components/Translate/I18n';
import { AcqOperator } from '../../interfaces/platform/AcqOperator';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { HeaderCheckBoxSelectListElement } from '../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { AcqOperatorLoader } from '../../modules/mnp/AcqOperatorLoader';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import CardHeaderExtRight from '../../components/Heading/CardHeaderExtRight';
import oplAppStyle from "../../assets/themes/OPL/jss/App/OplAppStyle";

interface PortInListProps {
    classes: any;
    dispatch: any;

    showMainLoader(value: boolean): void;
}

interface PortInListState {
    filters: Array<Filter>;
    orders: Array<Order>;
    items: PliCbd2CollectionInterface | null;
    acqOperators: Array<AcqOperator>;
    platformResellers: Array<HeaderCheckBoxSelectListElement>;
    acqOperatorHeader: Array<HeaderCheckBoxSelectListElement>;
}

class PortInList extends PureComponent<PortInListProps, PortInListState> {
    private itemLoader: ItemLoaders;

    private platformResellersLoader: PlatformResellerLoader;

    private acqOperatorLoader: AcqOperatorLoader;

    constructor(props: PortInListProps, context: PortInListState) {
        super(props, context);

        this.state = {
            filters: [],
            orders: [],
            items: null,
            acqOperators: [],
            platformResellers: [],
            acqOperatorHeader: [],
        };
        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.platformResellersLoader = new PlatformResellerLoader(this.itemLoader);
        this.acqOperatorLoader = new AcqOperatorLoader(this.itemLoader);
    }

    componentDidMount(): void {
        this.loadAcqOperators();
        this.loadPlatformResellers();
    }

    loadPlatformResellers = (): void => {
        this.platformResellersLoader.loadPlatformResellers({
            callback: () => {
                this.setState({ platformResellers: this.platformResellersLoader.getPlatformResellersHeaderList() });
            },
            filters: [{ name: 'deleted', value: 0 }],
        });
    };

    loadAcqOperators = (): void => {
        this.acqOperatorLoader.loadAcqOperators({
            callback: () => {
                this.setState(
                    {
                        acqOperators: this.acqOperatorLoader.getAcqOperators(),
                        acqOperatorHeader: this.acqOperatorLoader.getAcqOperatorsHeaderList(),
                    },
                    this.setDefaultFilter
                );
            },
        });
    };

    setDefaultFilter = (): void => {
        this.setState(
            {
                filters: [
                    { name: 'eventType', value: 'E13' },
                    { name: 'npType', value: 'MNP' },
                    { name: 'recipientFlag', value: true },
                ],
                orders: [],
            },
            (): void => this.firstLoad()
        );
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    updateOrderListRecipient = (orders: Array<Order>): void => {
        this.setState({ orders: orders }, this.firstLoad);
    };

    updateFilterPlatformResellerListRecipient = (filters: Array<Filter>): void => {
        this.setState({ filters: this.platformResellersLoader.updateFilterRptSearch(filters, 'recipient') });
    };

    updateFilterAcqOperatorListRecipient = (filters: Array<Filter>): void => {
        this.setState({ filters: this.acqOperatorLoader.updateFilterRptSearch(filters, 'donor') });
    };

    paginationCallbackFunction = (uri: string): void => {
        this.props.showMainLoader(true);
        this.itemLoader.paginationCallWithCallback(
            uri,
            'load_pli_cbd_2_list_e13_in',
            (data: PliCbd2CollectionInterface): void => {
                this.setState({ items: data });
                this.props.showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    firstLoad = (): void => {
        const { filters, orders } = this.state;
        this.props.showMainLoader(true);
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/pli_cbd2_cases')),
            'load_pli_cbd_2_list_e13_in',
            filters,
            orders,
            (data: PliCbd2CollectionInterface): void => {
                this.setState({ items: data });
                this.props.showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    render(): ReactNode {
        const { classes } = this.props;
        const { filters, orders, items, acqOperators, platformResellers, acqOperatorHeader } = this.state;
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeaderExtRight
                            icon={<Storage />}
                            trans="mnp_cases:h.portin_numbers"
                            additionalContent={
                                <CustomTextButtom callback={this.firstLoad} callbackParam={{}}  label="mnp_cases:h.search" />
                            }
                        />
                        <CardBody style={{ minHeight: '450px' }}>
                            <GridContainer>
                                <GridItem xs={12} md={12} lg={12}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="none" align="center">
                                                    <TableHeaderContentCell
                                                        textAlign="left"
                                                        title="mnp_cases:h.mnpcaseid"
                                                        fieldName="caseId"
                                                        showSort={true}
                                                        onlyFilter={false}
                                                        defaultDirection="desc"
                                                        searchFieldType="string"
                                                        filters={filters}
                                                        sort={orders}
                                                        updateOrderList={this.updateOrderList}
                                                        updateFilterList={this.updateFilterList}
                                                        searchActionCallback={this.firstLoad}
                                                    />
                                                </TableCell>
                                                <TableCell padding="none" align="center">
                                                    <TableHeaderContentCell
                                                        textAlign="center"
                                                        title="mnp_cases:h.msisdn"
                                                        fieldName="msisdn"
                                                        showSort={true}
                                                        onlyFilter={false}
                                                        defaultDirection="desc"
                                                        searchFieldType="string"
                                                        filters={filters}
                                                        sort={orders}
                                                        updateOrderList={this.updateOrderList}
                                                        updateFilterList={this.updateFilterList}
                                                        searchActionCallback={this.firstLoad}
                                                    />
                                                </TableCell>
                                                <TableCell padding="none" align="center">
                                                    <TableHeaderContentCell
                                                        textAlign="right"
                                                        title="mnp_cases:h.port_in_date"
                                                        fieldName="portingDate"
                                                        showSort={true}
                                                        onlyFilter={false}
                                                        defaultDirection="desc"
                                                        searchFieldType="date"
                                                        dateFormat="RRRR-MM-DD"
                                                        dateFromTo={true}
                                                        breakLine={true}
                                                        timeFormat={false}
                                                        filters={filters}
                                                        sort={orders}
                                                        updateOrderList={this.updateOrderList}
                                                        updateFilterList={this.updateFilterList}
                                                        searchActionCallback={this.firstLoad}
                                                    />
                                                </TableCell>
                                                <TableCell padding="none" align="center">
                                                    <TableHeaderContentCell
                                                        textAlign="center"
                                                        title="mnp_cases:h.donor"
                                                        fieldName="donor"
                                                        showSort={true}
                                                        onlyFilter={false}
                                                        defaultDirection="desc"
                                                        searchFieldType="select"
                                                        selectComponent="headerCheckBoxSimpleList"
                                                        elementList={acqOperatorHeader}
                                                        filters={filters}
                                                        sort={orders}
                                                        updateOrderList={this.updateOrderListRecipient}
                                                        updateFilterList={this.updateFilterAcqOperatorListRecipient}
                                                        searchActionCallback={this.firstLoad}
                                                    />
                                                </TableCell>
                                                <TableCell padding="none" align="center">
                                                    <TableHeaderContentCell
                                                        textAlign="center"
                                                        title="mnp_cases:h.recipient"
                                                        fieldName="recipient"
                                                        showSort={true}
                                                        onlyFilter={false}
                                                        defaultDirection="desc"
                                                        searchFieldType="select"
                                                        selectComponent="headerCheckBoxSimpleList"
                                                        elementList={platformResellers}
                                                        filters={filters}
                                                        sort={orders}
                                                        updateOrderList={this.updateOrderListRecipient}
                                                        updateFilterList={this.updateFilterPlatformResellerListRecipient}
                                                        searchActionCallback={this.firstLoad}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {items &&
                                                items['hydra:member'] &&
                                                items['hydra:member'].map((item: PliCbd2Interface) => {
                                                    return (
                                                        <PliCbd2PortInRow
                                                            key={'plicbd2_' + item.id}
                                                            pliCbd2={item}
                                                            classes={classes}
                                                            acqOperators={acqOperators}
                                                        />
                                                    );
                                                })}
                                            {items && items['hydra:member'] && items['hydra:member'].length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={5}>
                                                        <I18n trans="mnp_cases:h.no_result" />
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    {items && items['hydra:view'] && (
                                                        <Pager callback={this.paginationCallbackFunction} views={items} />
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(oplAppStyle)
)(PortInList);
